import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// I token di dimensione font custom (text-hero, text-h2, text-body in index.css) non sono nella
// scala di default di Tailwind: senza questa estensione tailwind-merge li legge come colori e li
// scarta scambiandoli per conflitti con text-ink/text-sea/ecc.
const twMerge = extendTailwindMerge({ extend: { theme: { text: ['hero', 'h2', 'body'] } } })

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
